import { render, staticRenderFns } from "./CreateLinkPopup.vue?vue&type=template&id=02538d8e&scoped=true&"
import script from "./CreateLinkPopup.vue?vue&type=script&lang=ts&"
export * from "./CreateLinkPopup.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLinkPopup.vue?vue&type=style&index=0&id=02538d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02538d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02538d8e')) {
      api.createRecord('02538d8e', component.options)
    } else {
      api.reload('02538d8e', component.options)
    }
    module.hot.accept("./CreateLinkPopup.vue?vue&type=template&id=02538d8e&scoped=true&", function () {
      api.rerender('02538d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/CreateLinkPopup.vue"
export default component.exports